import React, { useEffect, useRef } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet'; // Import Leaflet
import FloodMapGeoJSONLayer from './FloodMapGeoJSONLayer.js';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';


const markerIcon = L.icon({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [25, 41], // Size of the icon
  iconAnchor: [12, 41], // Point of the icon which will correspond to marker's location
  popupAnchor: [1, -34], // Point from which the popup should open relative to the iconAnchor
  shadowSize: [41, 41] // Size of the shadow
});

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error("Error in map component:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render any custom fallback UI
      return <div style={this.props.style || {}}>Unable to display Map</div>;
    }

    return this.props.children; 
  }
}


const GeoJSONBounds = ({ geoJSON }) => {
    const map = useMap();

    useEffect(() => {
        if (geoJSON) {
            const layer = L.geoJSON(geoJSON);
            const bounds = layer.getBounds();
            try { map.fitBounds(bounds); } catch(error) {}
        }
    }, [geoJSON, map]);

    return null;
};

/**
 * Base Map Class
 * 	- Centres of the position as specified in lat, lng with zoom level set
 * 			OR
 *  - If geoJSON is passed, centres on the polygons within the geoJSON
 */
const StaticNonStaticMapBase = (
	{
		children,
        lat,
		lng,
        noDefaultMarker,
        noPopup = false,
		zoom = 13,
		label,
		style,
		geoJSON,
		zoomControl = false, 
		scrollWheelZoom = false,
		dragging = false,
		touchZoom = false,
		additionalCustomGeoJSON,
        inhibitAttribForTinySize = false
	}
) => {
    const position = [lat ||-1, lng || -1.01];
    const mapRef = useRef();
    if((geoJSON && (!geoJSON.features[0] || !geoJSON.features[0].geometry))) {
        return <div style={style}><i>No map to show for this area</i></div>;
    }
    return (
        <MapErrorBoundary>
            <MapContainer
            	center={position}
            	zoom={zoom}
            	zoomControl={zoomControl}
            	scrollWheelZoom={scrollWheelZoom}
            	dragging={dragging}
            	touchZoom={touchZoom}
            	style={style}
            	ref={mapRef}
                whenCreated={mapInstance => {
                    mapRef.current = mapInstance;
                }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution={inhibitAttribForTinySize === false ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' : '&copy; <a href="https://www.openstreetmap.org/copyright">OSM contrib.</a>'}
                />
                {!noDefaultMarker && <Marker position={position} icon={markerIcon}>
                    {!noPopup && <Popup>{label}</Popup>}
                </Marker>}
                {geoJSON && <FloodMapGeoJSONLayer geoJSON={geoJSON} />}
                {geoJSON && <GeoJSONBounds geoJSON={geoJSON} />}
                {additionalCustomGeoJSON}
                {children}
            </MapContainer>
        </MapErrorBoundary>
    );
};

export default StaticNonStaticMapBase;
